import React from "react";
import {
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem
} from 'mdbreact';
import { connect } from 'react-redux';
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';



import { GetListaPDFEnAPI, ObtenerLicenciasSertecFacturacionEnAPI, GetListaHTMLEnAPI, GetCSVEnAPI } from "../../action/actionCreatorsRequests";
import {
    descargarPdfPasandoBase64,
    traducirPagina, convertirAMesACodigo, mostarReferenciasEnPantalla, descargarDocPasandoBase64Generico, MSGERROR, convertirCodigoAMeses, obtenerUsuario, obtenerFechaLocalObjeto

} from "../../librerias/funciones"

import FichaMantenimientoFacturacion from "./FichaMantenimientoFacturacion.jsx";
import { CPDia_Mes_Anyo } from "../CPDiaMesAnyo";
import { Pagination, Modal, Select } from 'antd';
import {
    MenuOutlined,
    PrinterOutlined,
    EyeOutlined

} from '@ant-design/icons';
import { Layout } from 'antd';
import FichaImpresionGenerico from "../../components/FichaImpresionGenerico";
const { Content } = Layout;
const { Option } = Select;

const LicenciasFacturacion = ({ activeItemReferencia, configApp, usuario, props }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)


    const [DOC_HTML, setDOC_HTML] = React.useState("");


    const [hayLicencias, seHayLicencias] = React.useState(false);

    const [licencias, setLicencias] = React.useState([]);
    const [totales, setTotales] = React.useState({});
    const [abrirImpresion, setAbrirImpresion] = React.useState(false);
    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [mesesDelAnio, setMesesDelAnio] = React.useState(
        [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ]
    );

    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [abrirFichaEstadistica, setAbrirFichaEstadistica] = React.useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = React.useState({});

    const [filtroLocal, setFiltroLocal] = React.useState({

        FECHA_PARTIDA: "",

        ACCION_DESDE: 0,
        ACCION_HASTA: 0,
        ACCION_GRUPAL: 0,
        ANYO_SELECCIONADO: 0,
        CODIGO_MES: 0,
        MES_SELECCIONADO: ""
    });




    const obtenerLicenciasActivas = (MES, ANYO, ID_SOCIO) => {
        setLicencias([])
        setTotales({})

        ObtenerLicenciasSertecFacturacionEnAPI(MES, ANYO, ID_SOCIO).then((licencia) => {
            if (licencia !== undefined) {
                if (licencia.REGISTROS !== undefined && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                    setLicencias(licencia.REGISTROS)
                    setTotales(licencia.RESUMEN)
                } else {
                    setLicencias(null)
                    setTotales(null)
                }
            }
        })
    }


    const buscarDocumento = () => {
        const TITULO = `${traducirPagina("Facturacion").toUpperCase()}  ${traducirPagina(filtroLocal.MES_SELECCIONADO).toUpperCase()} ${filtroLocal.ANYO_SELECCIONADO}`;
        const SUBTITULO = `${traducirPagina("Licencias_facturacion").toUpperCase()} SERTEC`;
        GetListaHTMLEnAPI(licencias, TITULO, SUBTITULO).then((doc) => {
            if (doc !== undefined) {
                if (doc !== null || doc !== "") {
                    setDOC_HTML(doc.HTML)
                } else {
                    setDOC_HTML(null)
                }
            }
        })
    }

    const buscarDocumentoPDF = () => {
        const TITULO = `${traducirPagina("Facturacion").toUpperCase()}  ${traducirPagina(filtroLocal.MES_SELECCIONADO).toUpperCase()} ${filtroLocal.ANYO_SELECCIONADO}`;
        const SUBTITULO = `${traducirPagina("Licencias_facturacion").toUpperCase()} SERTEC`;
        GetListaPDFEnAPI(licencias, TITULO, SUBTITULO).then((doc) => {
            if (doc !== undefined) {
                if (doc.PDF !== "" && doc.PDF !== null) {
                    descargarPdfPasandoBase64(doc.PDF)
                }
            }
        })
    }

    const buscarDocumentoCSV = () => {
        GetCSVEnAPI(licencias).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")

                }
            }
        })
    }



    const actualizarTablaFecha = (OBJ_FECHA) => {
        const { FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, CODIGO_MES, ANYO_SELECCIONADO, MES_SELECCIONADO } = OBJ_FECHA
        filtroLocal.FECHA_PARTIDA = FECHA_PARTIDA;
        filtroLocal.ACCION_DESDE = ACCION_DESDE;
        filtroLocal.ACCION_HASTA = ACCION_HASTA;
        filtroLocal.CODIGO_MES = CODIGO_MES;
        filtroLocal.ANYO_SELECCIONADO = ANYO_SELECCIONADO;
        filtroLocal.MES_SELECCIONADO = MES_SELECCIONADO

        setFiltroLocal({ ...filtroLocal })

        obtenerLicenciasActivas(CODIGO_MES, ANYO_SELECCIONADO, socioSeleccionado)
    }




    const initFecha = (OBJ_FECHA, MODIFICAR_OBJETO) => {
        //Se modifica el init del componete
        let fechaLocal = obtenerFechaLocalObjeto(false);

        let listaAnios = [];
        for (var i = 2021; i <= fechaLocal.ANIO; i++) {
            listaAnios.push(i)
        }
        //setAnios(listaAnios)

        OBJ_FECHA.CAMBIO_MES = true;
        OBJ_FECHA.CAMBIO_ANIO = true;
        OBJ_FECHA.ACCION_DESDE = 0;
        OBJ_FECHA.ACCION_HASTA = 1;
        OBJ_FECHA.ANYOS = listaAnios
        MODIFICAR_OBJETO({ ...OBJ_FECHA })

        //Obtenemos los valores 
        const { FECHA_PARTIDA, ACCION_DESDE, ACCION_HASTA, CODIGO_MES, ANYO_SELECCIONADO, MES_SELECCIONADO } = OBJ_FECHA
        filtroLocal.FECHA_PARTIDA = FECHA_PARTIDA;
        filtroLocal.ACCION_DESDE = ACCION_DESDE;
        filtroLocal.ACCION_HASTA = ACCION_HASTA;
        filtroLocal.ANYO_SELECCIONADO = ANYO_SELECCIONADO;
        filtroLocal.CODIGO_MES = CODIGO_MES
        filtroLocal.MES_SELECCIONADO = MES_SELECCIONADO

        setFiltroLocal({ ...filtroLocal })


        let accesoLicencia = obtenerUsuario();
        setSociosLocal(accesoLicencia.SOCIOS)


        if (usuario.ID_ROL === 2) {
            obtenerLicenciasActivas(CODIGO_MES, ANYO_SELECCIONADO, "")

        } else {
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)
            obtenerLicenciasActivas(CODIGO_MES, ANYO_SELECCIONADO, accesoLicencia.SOCIOS[0].ID_SOCIO)
        }
    }


    /*
    if (!hayLicencias && activeItemReferencia === "LICENCIAS_FACTURACION") {
        //let accesoLicencia = obtenerUsuario();
        seHayLicencias(true)


    } else {
        if (activeItemReferencia !== "LICENCIAS_FACTURACION" && hayLicencias) {
            seHayLicencias(false)
        }
    }
*/



    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })





    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - ${traducirPagina("Licencias_facturacion").toUpperCase()}`}
        </>,
        document.getElementById("tituloMenu")
    );




    return (
        <>


            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1">
                    {sociosLocal !== null ?
                        <Select
                            showSearch
                            allowClear={usuario.ID_ROL === 2 ? true : false}
                            size={"large"}

                            value={socioSeleccionado === 0 ? <span style={{ color: '#999' }}>{traducirPagina("Seleccione_socio").toUpperCase()}</span> : socioSeleccionado}

                            style={{ width: "240px", textAlign: 'left', marginRight: '10px' }}
                            optionFilterProp="children"
                            onChange={(e) => {

                                if (e === undefined || e === null) {
                                    setSocioSeleccionado(0);
                                    obtenerLicenciasActivas(filtroLocal.CODIGO_MES, filtroLocal.ANYO_SELECCIONADO, "")

                                } else {
                                    //setFiltroActivo(0)
                                    setSocioSeleccionado(parseInt(e));
                                    obtenerLicenciasActivas(filtroLocal.CODIGO_MES, filtroLocal.ANYO_SELECCIONADO, parseInt(e))

                                }
                            }}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {sociosLocal.length > 0 ?
                                sociosLocal.map((socio) =>
                                    <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                )
                                :
                                null
                            }
                        </Select>
                        :
                        <div style={{ textAlign: 'center' }}>
                            <h4>{traducirPagina("Info_error_socio")}</h4>
                        </div>
                    }


                </div>

                <div className="mantenimiento_item2" style={{ gap: '10px', fontSize: '16px' }}>
                    {totales !== undefined && totales !== null && Object.keys(totales).length > 0 ?
                        <>
                            <div className="txt_titulo">{`${traducirPagina("Talleres").toUpperCase()}:`} <span className="txt_descripcion"> {totales.TOTAL_CLIENTES} </span></div>
                            <div className="txt_titulo">{`${traducirPagina("Mostradores").toUpperCase()}: `} <span className="txt_descripcion"> {totales.TOTAL_MOSTRADORES} </span> </div>

                            <div className="txt_titulo">{`${traducirPagina("Total_demo").toUpperCase()}:  `} <span className="txt_descripcion">{totales.TOTEL_DEMO_MOSTRADORES}  </span> </div>

                            <div className="txt_titulo">{`${traducirPagina("Total").toUpperCase()}: `} <span className="txt_descripcion"> {totales.TOTAL_LICENCIAS} </span> </div>
                        </>
                        :
                        null
                    }


                    <CPDia_Mes_Anyo
                        ACTUALIZAR_TABLA={actualizarTablaFecha}
                        FECHA_INICIAL={initFecha}
                        OCULTAR_DIA={true}
                    >
                    </CPDia_Mes_Anyo>

                    {/*

                    <MDBDropdown>
                        <MDBDropdownToggle nav>
                            <div style={{ padding: '8px 20px', backgroundColor: seCambioElMes ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                {mesSeleccionado.toUpperCase()}
                            </div>
                        </MDBDropdownToggle>

                        <MDBDropdownMenu right >
                            {mesesDelAnio.map((mes, i) =>
                                <MDBDropdownItem style={{ padding: '0px 5px' }} key={i} onClick={(e) => {
                                    setMesSeleccionado(e.target.innerText);
                                    setSeCambioElMes(true);

                                    obtenerLicenciasActivas(parseInt(convertirAMesACodigo(e.target.innerText)), parseInt(anioSeleccionado), parseInt(socioSeleccionado))

                                }}>  {mes.toUpperCase()}</MDBDropdownItem>
                            )}
                        </MDBDropdownMenu>
                    </MDBDropdown>

                    <MDBDropdown>
                        <MDBDropdownToggle nav>
                            <div style={{ padding: '8px 20px', backgroundColor: seCambioElAnio ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }}>
                                {anioSeleccionado}
                            </div>
                        </MDBDropdownToggle>

                        <MDBDropdownMenu right >
                            {anios !== null ?
                                anios.map((anio, i) =>
                                    <MDBDropdownItem key={i} onClick={(e) => {
                                        setAnioSeleccionado(e.target.innerText);
                                        //setSocioSeleccionado(0);
                                        obtenerLicenciasActivas(parseInt(convertirAMesACodigo(mesSeleccionado)), parseInt(e.target.innerText), parseInt(socioSeleccionado))
                                        //setSocioSeleccionado(0);
                                        //obtenerLicenciasActivas(parseInt(convertirAMesACodigo(mesSeleccionado)),parseInt(e.target.innerText),"")


                                        setSeCambioElAnio(true)
                                    }}>  {anio}</MDBDropdownItem>
                                )
                                :
                                null
                            }
                        </MDBDropdownMenu>
                    </MDBDropdown>
 */}
                    <PrinterOutlined style={{ lineHeight: '40px', fontSize: '20px', verticalAlign: 'bottom', marginLeft: '10px', color: '#1890ff', cursor: 'pointer' }} onClick={(e) => { setAbrirImpresion(true); buscarDocumento(); }} />
                </div>
            </div>




            <div className="margen_tabla">
                {licencias === null ?
                    <div style={{ textAlign: 'center' }}>
                        <h4>{traducirPagina("Sin_registros")}</h4>
                    </div>
                    :
                    licencias.length > 0 ?
                        <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>
                            <table style={{ border: '1px solid #d9d9d9', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Socio").toUpperCase()} </th>
                                        <th style={{ width: '80px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Pais").toUpperCase()}</th>
                                        <th style={{ width: '175px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Total_demo").toUpperCase()} </th>

                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Mostradores").toUpperCase()} </th>
                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Talleres").toUpperCase()} </th>
                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Total").toUpperCase()} </th>
                                        <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Matriculas").toUpperCase()} </th>
                                        <th style={{ width: '120px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{"GT ESTIMATE"} </th>
                                        <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{"OEM"} </th>
                                        <th style={{ width: '115px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Doc_tecnica").toUpperCase()} </th>



                                        <th style={{ width: '45px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{ } </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {licencias.map((licencia, i) =>
                                        <tr key={i} style={{ backgroundColor: '#fff' }}>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.SOCIO}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{licencia.PAIS}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.DEMO_MOSTRADORES}</td>

                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.MOSTRADORES}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.CLIENTES}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.TOTAL}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.MATRICULAS}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.GTESTIMATE}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.OEM}</td>
                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{licencia.DOCUMENTACION_TECNICA}</td>


                                            <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>
                                                <div className="flex-container-Grow-Simple">
                                                    <div style={{ margin: '0px 2px' }} >
                                                        <button title={"Más ìnformación"} onClick={() => {
                                                            setRegistroSeleccionado(licencia)
                                                            setAbrirFichaEstadistica(true)
                                                        }}
                                                            className="btn-matricula  estiloBotonRemove paddindDeTres">
                                                            <EyeOutlined style={{ cursor: 'pointer', fontSize: '20px', color: '#000' }} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                }
            </div>


            {abrirImpresion ?
                <FichaImpresionGenerico
                    title={traducirPagina("Impresion_doc").toUpperCase()}
                    ABRIR_FICHA={abrirImpresion}
                    CERRAR_FICHA={setAbrirImpresion}

                    DOCUMENTO={DOC_HTML}
                    MODIFICAR_DOCUMENTO={setDOC_HTML}
                    DESCARGAR_DOCUMENTO={buscarDocumentoPDF}
                    DESCARGAR_CSV={buscarDocumentoCSV}
                    VER_CSV={true}

                ></FichaImpresionGenerico>
                :
                null
            }

            {abrirFichaEstadistica ?
                <FichaMantenimientoFacturacion
                    title={traducirPagina("Historial_facturacion").toUpperCase()}
                    ABRIR_FICHA={abrirFichaEstadistica}
                    CERRAR_FICHA={setAbrirFichaEstadistica}


                    MES={filtroLocal.CODIGO_MES}
                    ANYO={filtroLocal.ANYO_SELECCIONADO}
                    ID_SOCIO={parseInt(socioSeleccionado)}
                    REGISTRO_SELECCIONADO={registroSeleccionado}

                ></FichaMantenimientoFacturacion>
                :
                null

            }
        </>
    );
}

LicenciasFacturacion.propTypes = {
    EVENTO_MENU: PropTypes.func
};


const mapStateToProps = (state, props) => {
    return {
        props: props,
        search: state.searchValue,
        listaTree: state.listaTree,
        configApp: state.configApp,
        activeItemReferencia: state.activeItemReferencia,
        usuario: state.usuario
    };
}

export default connect(mapStateToProps)(LicenciasFacturacion);




